import { FC } from 'react';
import { Box, BoxProps } from '@mui/material';
import BookingCalendarToolbarDateRange from '@pages/booking/components/BookingCalendarToolbarDateRange';
import BookingCalendarToolbarFilters, {
    BookingCalendarToolbarFiltersProps,
} from '@pages/booking/components/BookingCalendarToolbarFilters';
import { useBookingConfigContext } from '@pages/booking/contexts/BookingConfigContext';

type BookingCalendarToolbarProps = BookingCalendarToolbarFiltersProps & {
    toolbarProps?: BoxProps;
};

const BookingCalendarToolbar: FC<BookingCalendarToolbarProps> = ({
    devicesSearch,
    setDevicesSearch,
    devicesLocation,
    setDevicesLocation,
    devicesType,
    setDevicesType,
    toolbarProps,
}) => {
    const { selectMode } = useBookingConfigContext();

    return (
        <Box sx={{ display: 'flex', gap: 2, mb: 2, height: '36px', ...toolbarProps?.sx }} {...toolbarProps}>
            <BookingCalendarToolbarDateRange />
            {!selectMode && (
                <BookingCalendarToolbarFilters
                    devicesSearch={devicesSearch}
                    setDevicesSearch={setDevicesSearch}
                    devicesLocation={devicesLocation}
                    setDevicesLocation={setDevicesLocation}
                    devicesType={devicesType}
                    setDevicesType={setDevicesType}
                />
            )}
        </Box>
    );
};

export default BookingCalendarToolbar;
